let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("4gu5P")).then(() => parcelRequire('3LYMV'));